import isValueEmpty from '../../isValueEmpty';

export const errorMessage = __('The maximum allowed is %{maximum}');

export const validateMaximum = (value, maximum, maximumErrorLabel) => {
  let error;

  if (isValueEmpty(value)) {
    return error;
  }

  if (Number(value) > Number(maximum)) {
    error =
      maximumErrorLabel ||
      errorMessage.i__({
        maximum,
      });
  }

  return error;
};
